import { Bot, ChevronDownIcon, UserIcon } from "lucide-react";
import "./ExampleMessageFeed.scss";
import Spinner from "../../../../assets/icons/Spinner";
import MarkdownContainer from "../../../shared/markdown/MarkdownContainer";
import Message from "../../../../i18n/Message";
import ExampleToolUseBlock from "./ExampleToolUseBlock";
import { useUiMode } from "../context/UiModeContext";

const ExampleMessageFeed = ({ messages }) => {
  const { uiMode } = useUiMode();

  return (
    <div className={`example_messages_feed ${uiMode.toLowerCase()}_mode`}>
      {/*<div className="example_messages_feed_wrapper">*/}
      {!messages && <Spinner />}
      {messages &&
        messages.map((message, messageIdx) => {
          if (
            message.role === "user" &&
            message.content.find((item) => item.type === "tool_result")
          ) {
            return null; // handled in the assistant message earlier
          }
          return (
            <div
              key={message.uid}
              className={
                "example_message_container " +
                (message.role === "user" ? "user" : "") +
                (message.role === "assistant" ? "assistant" : "")
              }
            >
              <div className="avatar">
                {message.role === "user" && (
                  <div className="user_avatar">
                    <UserIcon color="#777" />
                  </div>
                )}
                {message.role === "assistant" && (
                  <div className="openai_avatar">
                    <Bot color="#fff" />
                  </div>
                )}
              </div>
              <div className="message_item_content">
                {message.content.map((block, blockIdx) => {
                  if (block.type === "text") {
                    return (
                      <MarkdownContainer key={blockIdx}>
                        {block.text}
                      </MarkdownContainer>
                    );
                  } else if (block.type === "tool_use") {
                    // tool use
                    return (
                      <ExampleToolUseBlock
                        key={blockIdx}
                        block={block}
                        messageIdx={messageIdx}
                        messages={messages}
                      />
                    );
                  }
                  return null;
                })}
              </div>
            </div>
          );
        })}
      {/*</div>*/}
    </div>
  );
};

export default ExampleMessageFeed;
